// CopyProcessorFeeTable.js
import React, { useState, useEffect, useMemo, useRef } from "react";
import { useLocation } from "react-router-dom";
import useCustomNavigate from "../../common_nextgen/common_components/Navigation/NextGenNavigation";
import Form from "../../common_nextgen/common_components/form/Form";
import {
  PRICE_SCHEDULE_MODES,
  isAddMode,
  isEditMode,
  isReadOnlyMode,
} from "../../common_nextgen/utils/Constants";
import { useAxios } from "../../common_nextgen/axios/AxiosHelper";
import { useToast } from "../../common_nextgen/hooks/ToastContext";
import FunctionKeys from "../../common_nextgen/common_components/FunctionKeys/FunctionKeys";
import { formFields } from "./CopyProcessorFeeTableConfig";
import { screenInfo } from "./CopyProcessorFeeTableConfig";
import { ROUTE_PATHS } from "../../common_nextgen/utils/Constants";

const CopyProcessorFeeTable = ({ mode }) => {
  const location = useLocation();
  const { state: stateVal } = location;
  let [currentState = {}] = [...stateVal].reverse();
  const previousState = [...stateVal];
  previousState.splice(stateVal.length - 1, 1);
  const {
    selectedPriceSchedules = [],
    previousScreen = ROUTE_PATHS.PATIENT_PAY_SCHEDULE,
    currentIndex: initialIndex = 0,
  } = currentState;
  const navigateToPage = useCustomNavigate();
  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const [constraintErrors, setConstraintErrors] = useState([]);
  const latestCopiedRecord = useRef(null);
  const toast = useToast();
  const { axios_helper_no_header } = useAxios();
  const initialFormData = useMemo(() => {
    const {
      pf3ProcFeeTable: dtlPf3ProcFeeTable = "",
      pf3ProcFeeTableDesc: dtlPf3ProcFeeTableDesc = "",
    } = selectedPriceSchedules[currentIndex];
    return {
      dtlPf3ProcFeeTable,
      dtlPf3ProcFeeTableDesc,
      dtlToTableId: "",
      dtlToDescription: "",
    };
  }, [selectedPriceSchedules, currentIndex]);

  const handleBack = () => {
    if (currentIndex < selectedPriceSchedules.length - 1) {
      setCurrentIndex(currentIndex + 1);
    } else {
      if (!latestCopiedRecord.current) {
        navigateToPage(previousScreen, previousState);
      } else {
        const [previousLastRecord = {}] = previousState.splice(
          previousState.length - 1,
          1
        );
        const { paramsData = {} } = previousLastRecord;
        const updatedParamsData = {
          ...paramsData,
          pf3ProcFeeTable: latestCopiedRecord.current["dtlToTableId"],
        };
        const updatedPreviousState = [
          ...previousState,
          { ...previousLastRecord, paramsData: updatedParamsData },
        ];
        navigateToPage(previousScreen, updatedPreviousState);
      }
    }
  };

  const getPageTitle = () => {
    const { screenTitle, screenNumber } = screenInfo;
    return (
      <>
        <span className="title">{screenTitle}</span>
        <span>{"-"}</span>
        <span className="screen-number">{screenNumber}</span>
      </>
    );
  };

  const submitForm = async (dataForSubmission) => {
    const data = {
      ...dataForSubmission,
      screenNumber: screenInfo.screenNumber,
    };
    const url = "api/pf3ProcessorFeTable/copy";
    const verb = "POST";
    try {
      const { responseStatus, responseData } = await axios_helper_no_header(
        verb,
        url,
        data,
        null
      );
      latestCopiedRecord.current = { ...responseData };
      toast.current.show({
        severity: "success",
        summary: "",
        detail: responseStatus.message,
        life: 3000,
      });
    } catch (error) {
      const {
        responseStatus: { displayErrorFields = null, message },
      } = error.data;
      if (displayErrorFields === null) {
        toast.current.show({
          severity: "error",
          summary: "",
          detail: message,
          life: 3000,
        });
      } else {
        setConstraintErrors(displayErrorFields);
      }
    }
  };

  const [keyFunc, keyName] = useMemo(() => {
    const keyFunc = {};
    const keyName = {};
    keyFunc["F12"] = handleBack;
    keyName["F12"] = "Back";
    return [keyFunc, keyName];
  }, [currentIndex]);

  return (
    <div className="grid container">
      <div className="col col-12">
        <FunctionKeys keyFunc={keyFunc} keyName={keyName} />
      </div>
      <div className="col col-12">
        <h1>{getPageTitle()}</h1>
      </div>
      <div className="col col-12">
        <Form
          formData={initialFormData}
          formFields={formFields}
          mode={mode}
          submitFormData={submitForm}
          constraintErrors={constraintErrors}
        />
      </div>
    </div>
  );
};

export default CopyProcessorFeeTable;
